module.exports = __webpack_public_path__ + "static/1.1.E.7 FORNA PLAN ETAJ-ab657760bd2a4d92586dacd81af42288.jpg";